// Guardian AI Expert Scan Service Protocol Definitions
// Expert-assisted scan requests, job queue, state machine, and reporting
//
// Version: v1
// Purpose: High-Trust Cybersecurity Marketplace - Expert scan workflow

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/expert/expert_scan.proto (package guardianai.v1.expert, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/expert/expert_scan.proto.
 */
export const file_guardianai_v1_expert_expert_scan: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.expert.ExpertScanRequest
 */
export type ExpertScanRequest = Message<"guardianai.v1.expert.ExpertScanRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId: string;

  /**
   * Empty if OPEN
   *
   * @generated from field: string assigned_expert_id = 3;
   */
  assignedExpertId: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanStatus status = 4;
   */
  status: ExpertScanStatus;

  /**
   * @generated from field: guardianai.v1.expert.ScanType scan_type = 5;
   */
  scanType: ScanType;

  /**
   * @generated from field: guardianai.v1.expert.ServiceTier service_tier = 6;
   */
  serviceTier: ServiceTier;

  /**
   * @generated from field: string title = 7;
   */
  title: string;

  /**
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * Scope definition
   *
   * @generated from field: guardianai.v1.expert.ScopeDefinition scope = 9;
   */
  scope?: ScopeDefinition;

  /**
   * Credit information
   *
   * @generated from field: int64 credits_locked = 10;
   */
  creditsLocked: bigint;

  /**
   * @generated from field: string escrow_id = 11;
   */
  escrowId: string;

  /**
   * Timestamps
   *
   * @generated from field: int64 created_at = 12;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 13;
   */
  updatedAt: bigint;

  /**
   * @generated from field: int64 claimed_at = 14;
   */
  claimedAt: bigint;

  /**
   * @generated from field: int64 started_at = 15;
   */
  startedAt: bigint;

  /**
   * @generated from field: int64 report_submitted_at = 16;
   */
  reportSubmittedAt: bigint;

  /**
   * @generated from field: int64 closed_at = 17;
   */
  closedAt: bigint;

  /**
   * SLA tracking
   *
   * @generated from field: int64 sla_deadline = 18;
   */
  slaDeadline: bigint;

  /**
   * @generated from field: bool sla_breached = 19;
   */
  slaBreached: boolean;

  /**
   * Credential vault reference (only visible during IN_PROGRESS)
   *
   * @generated from field: string credential_vault_id = 20;
   */
  credentialVaultId: string;
};

/**
 * @generated from message guardianai.v1.expert.ExpertScanRequest
 */
export type ExpertScanRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId?: string;

  /**
   * Empty if OPEN
   *
   * @generated from field: string assigned_expert_id = 3;
   */
  assignedExpertId?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanStatus status = 4;
   */
  status?: ExpertScanStatusJson;

  /**
   * @generated from field: guardianai.v1.expert.ScanType scan_type = 5;
   */
  scanType?: ScanTypeJson;

  /**
   * @generated from field: guardianai.v1.expert.ServiceTier service_tier = 6;
   */
  serviceTier?: ServiceTierJson;

  /**
   * @generated from field: string title = 7;
   */
  title?: string;

  /**
   * @generated from field: string description = 8;
   */
  description?: string;

  /**
   * Scope definition
   *
   * @generated from field: guardianai.v1.expert.ScopeDefinition scope = 9;
   */
  scope?: ScopeDefinitionJson;

  /**
   * Credit information
   *
   * @generated from field: int64 credits_locked = 10;
   */
  creditsLocked?: string;

  /**
   * @generated from field: string escrow_id = 11;
   */
  escrowId?: string;

  /**
   * Timestamps
   *
   * @generated from field: int64 created_at = 12;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 13;
   */
  updatedAt?: string;

  /**
   * @generated from field: int64 claimed_at = 14;
   */
  claimedAt?: string;

  /**
   * @generated from field: int64 started_at = 15;
   */
  startedAt?: string;

  /**
   * @generated from field: int64 report_submitted_at = 16;
   */
  reportSubmittedAt?: string;

  /**
   * @generated from field: int64 closed_at = 17;
   */
  closedAt?: string;

  /**
   * SLA tracking
   *
   * @generated from field: int64 sla_deadline = 18;
   */
  slaDeadline?: string;

  /**
   * @generated from field: bool sla_breached = 19;
   */
  slaBreached?: boolean;

  /**
   * Credential vault reference (only visible during IN_PROGRESS)
   *
   * @generated from field: string credential_vault_id = 20;
   */
  credentialVaultId?: string;
};

/**
 * Describes the message guardianai.v1.expert.ExpertScanRequest.
 * Use `create(ExpertScanRequestSchema)` to create a new message.
 */
export const ExpertScanRequestSchema: GenMessage<ExpertScanRequest, {jsonType: ExpertScanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 0);

/**
 * @generated from message guardianai.v1.expert.ScopeDefinition
 */
export type ScopeDefinition = Message<"guardianai.v1.expert.ScopeDefinition"> & {
  /**
   * IP addresses or CIDR ranges
   *
   * @generated from field: repeated string target_ips = 1;
   */
  targetIps: string[];

  /**
   * Domains to scan
   *
   * @generated from field: repeated string target_domains = 2;
   */
  targetDomains: string[];

  /**
   * Exclusions
   *
   * @generated from field: repeated string excluded_ips = 3;
   */
  excludedIps: string[];

  /**
   * AWS, GCP, Azure (for cloud audits)
   *
   * @generated from field: string cloud_provider = 4;
   */
  cloudProvider: string;

  /**
   * Free-text scope notes
   *
   * @generated from field: string additional_notes = 5;
   */
  additionalNotes: string;

  /**
   * Whether credential vault is needed
   *
   * @generated from field: bool requires_credentials = 6;
   */
  requiresCredentials: boolean;
};

/**
 * @generated from message guardianai.v1.expert.ScopeDefinition
 */
export type ScopeDefinitionJson = {
  /**
   * IP addresses or CIDR ranges
   *
   * @generated from field: repeated string target_ips = 1;
   */
  targetIps?: string[];

  /**
   * Domains to scan
   *
   * @generated from field: repeated string target_domains = 2;
   */
  targetDomains?: string[];

  /**
   * Exclusions
   *
   * @generated from field: repeated string excluded_ips = 3;
   */
  excludedIps?: string[];

  /**
   * AWS, GCP, Azure (for cloud audits)
   *
   * @generated from field: string cloud_provider = 4;
   */
  cloudProvider?: string;

  /**
   * Free-text scope notes
   *
   * @generated from field: string additional_notes = 5;
   */
  additionalNotes?: string;

  /**
   * Whether credential vault is needed
   *
   * @generated from field: bool requires_credentials = 6;
   */
  requiresCredentials?: boolean;
};

/**
 * Describes the message guardianai.v1.expert.ScopeDefinition.
 * Use `create(ScopeDefinitionSchema)` to create a new message.
 */
export const ScopeDefinitionSchema: GenMessage<ScopeDefinition, {jsonType: ScopeDefinitionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 1);

/**
 * @generated from message guardianai.v1.expert.CreateExpertScanRequest
 */
export type CreateExpertScanRequest = Message<"guardianai.v1.expert.CreateExpertScanRequest"> & {
  /**
   * @generated from field: string client_user_id = 1;
   */
  clientUserId: string;

  /**
   * @generated from field: guardianai.v1.expert.ScanType scan_type = 2;
   */
  scanType: ScanType;

  /**
   * @generated from field: guardianai.v1.expert.ServiceTier service_tier = 3;
   */
  serviceTier: ServiceTier;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: guardianai.v1.expert.ScopeDefinition scope = 6;
   */
  scope?: ScopeDefinition;

  /**
   * Credential vault (optional, encrypted)
   *
   * @generated from field: guardianai.v1.expert.CredentialVaultInput credentials = 7;
   */
  credentials?: CredentialVaultInput;

  /**
   * Legal consent
   *
   * @generated from field: bool consent_accepted = 8;
   */
  consentAccepted: boolean;

  /**
   * @generated from field: string consent_ip_address = 9;
   */
  consentIpAddress: string;

  /**
   * @generated from field: string consent_user_agent = 10;
   */
  consentUserAgent: string;
};

/**
 * @generated from message guardianai.v1.expert.CreateExpertScanRequest
 */
export type CreateExpertScanRequestJson = {
  /**
   * @generated from field: string client_user_id = 1;
   */
  clientUserId?: string;

  /**
   * @generated from field: guardianai.v1.expert.ScanType scan_type = 2;
   */
  scanType?: ScanTypeJson;

  /**
   * @generated from field: guardianai.v1.expert.ServiceTier service_tier = 3;
   */
  serviceTier?: ServiceTierJson;

  /**
   * @generated from field: string title = 4;
   */
  title?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: guardianai.v1.expert.ScopeDefinition scope = 6;
   */
  scope?: ScopeDefinitionJson;

  /**
   * Credential vault (optional, encrypted)
   *
   * @generated from field: guardianai.v1.expert.CredentialVaultInput credentials = 7;
   */
  credentials?: CredentialVaultInputJson;

  /**
   * Legal consent
   *
   * @generated from field: bool consent_accepted = 8;
   */
  consentAccepted?: boolean;

  /**
   * @generated from field: string consent_ip_address = 9;
   */
  consentIpAddress?: string;

  /**
   * @generated from field: string consent_user_agent = 10;
   */
  consentUserAgent?: string;
};

/**
 * Describes the message guardianai.v1.expert.CreateExpertScanRequest.
 * Use `create(CreateExpertScanRequestSchema)` to create a new message.
 */
export const CreateExpertScanRequestSchema: GenMessage<CreateExpertScanRequest, {jsonType: CreateExpertScanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 2);

/**
 * @generated from message guardianai.v1.expert.CredentialVaultInput
 */
export type CredentialVaultInput = Message<"guardianai.v1.expert.CredentialVaultInput"> & {
  /**
   * SSH_KEY, PASSWORD, API_KEY, AWS_CREDENTIALS
   *
   * @generated from field: string credential_type = 1;
   */
  credentialType: string;

  /**
   * Client-side encrypted
   *
   * @generated from field: bytes encrypted_value = 2;
   */
  encryptedValue: Uint8Array;

  /**
   * Which key was used for encryption
   *
   * @generated from field: string public_key_id = 3;
   */
  publicKeyId: string;

  /**
   * Auto-expire after job completion
   *
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.expert.CredentialVaultInput
 */
export type CredentialVaultInputJson = {
  /**
   * SSH_KEY, PASSWORD, API_KEY, AWS_CREDENTIALS
   *
   * @generated from field: string credential_type = 1;
   */
  credentialType?: string;

  /**
   * Client-side encrypted
   *
   * @generated from field: bytes encrypted_value = 2;
   */
  encryptedValue?: string;

  /**
   * Which key was used for encryption
   *
   * @generated from field: string public_key_id = 3;
   */
  publicKeyId?: string;

  /**
   * Auto-expire after job completion
   *
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.expert.CredentialVaultInput.
 * Use `create(CredentialVaultInputSchema)` to create a new message.
 */
export const CredentialVaultInputSchema: GenMessage<CredentialVaultInput, {jsonType: CredentialVaultInputJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 3);

/**
 * @generated from message guardianai.v1.expert.ExpertScanRequestResponse
 */
export type ExpertScanRequestResponse = Message<"guardianai.v1.expert.ExpertScanRequestResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;
};

/**
 * @generated from message guardianai.v1.expert.ExpertScanRequestResponse
 */
export type ExpertScanRequestResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;
};

/**
 * Describes the message guardianai.v1.expert.ExpertScanRequestResponse.
 * Use `create(ExpertScanRequestResponseSchema)` to create a new message.
 */
export const ExpertScanRequestResponseSchema: GenMessage<ExpertScanRequestResponse, {jsonType: ExpertScanRequestResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 4);

/**
 * @generated from message guardianai.v1.expert.ListMyRequestsRequest
 */
export type ListMyRequestsRequest = Message<"guardianai.v1.expert.ListMyRequestsRequest"> & {
  /**
   * @generated from field: string client_user_id = 1;
   */
  clientUserId: string;

  /**
   * 0 for all
   *
   * @generated from field: guardianai.v1.expert.ExpertScanStatus status_filter = 2;
   */
  statusFilter: ExpertScanStatus;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.expert.ListMyRequestsRequest
 */
export type ListMyRequestsRequestJson = {
  /**
   * @generated from field: string client_user_id = 1;
   */
  clientUserId?: string;

  /**
   * 0 for all
   *
   * @generated from field: guardianai.v1.expert.ExpertScanStatus status_filter = 2;
   */
  statusFilter?: ExpertScanStatusJson;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.expert.ListMyRequestsRequest.
 * Use `create(ListMyRequestsRequestSchema)` to create a new message.
 */
export const ListMyRequestsRequestSchema: GenMessage<ListMyRequestsRequest, {jsonType: ListMyRequestsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 5);

/**
 * @generated from message guardianai.v1.expert.ListRequestsResponse
 */
export type ListRequestsResponse = Message<"guardianai.v1.expert.ListRequestsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.expert.ExpertScanRequest requests = 1;
   */
  requests: ExpertScanRequest[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.expert.ListRequestsResponse
 */
export type ListRequestsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.expert.ExpertScanRequest requests = 1;
   */
  requests?: ExpertScanRequestJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.expert.ListRequestsResponse.
 * Use `create(ListRequestsResponseSchema)` to create a new message.
 */
export const ListRequestsResponseSchema: GenMessage<ListRequestsResponse, {jsonType: ListRequestsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 6);

/**
 * @generated from message guardianai.v1.expert.GetRequestStatusRequest
 */
export type GetRequestStatusRequest = Message<"guardianai.v1.expert.GetRequestStatusRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * For permission check
   *
   * @generated from field: string viewer_user_id = 2;
   */
  viewerUserId: string;
};

/**
 * @generated from message guardianai.v1.expert.GetRequestStatusRequest
 */
export type GetRequestStatusRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * For permission check
   *
   * @generated from field: string viewer_user_id = 2;
   */
  viewerUserId?: string;
};

/**
 * Describes the message guardianai.v1.expert.GetRequestStatusRequest.
 * Use `create(GetRequestStatusRequestSchema)` to create a new message.
 */
export const GetRequestStatusRequestSchema: GenMessage<GetRequestStatusRequest, {jsonType: GetRequestStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 7);

/**
 * @generated from message guardianai.v1.expert.CancelRequestRequest
 */
export type CancelRequestRequest = Message<"guardianai.v1.expert.CancelRequestRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.expert.CancelRequestRequest
 */
export type CancelRequestRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.expert.CancelRequestRequest.
 * Use `create(CancelRequestRequestSchema)` to create a new message.
 */
export const CancelRequestRequestSchema: GenMessage<CancelRequestRequest, {jsonType: CancelRequestRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 8);

/**
 * @generated from message guardianai.v1.expert.CancelRequestResponse
 */
export type CancelRequestResponse = Message<"guardianai.v1.expert.CancelRequestResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: int64 refunded_credits = 3;
   */
  refundedCredits: bigint;

  /**
   * @generated from field: string new_status = 4;
   */
  newStatus: string;
};

/**
 * @generated from message guardianai.v1.expert.CancelRequestResponse
 */
export type CancelRequestResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: int64 refunded_credits = 3;
   */
  refundedCredits?: string;

  /**
   * @generated from field: string new_status = 4;
   */
  newStatus?: string;
};

/**
 * Describes the message guardianai.v1.expert.CancelRequestResponse.
 * Use `create(CancelRequestResponseSchema)` to create a new message.
 */
export const CancelRequestResponseSchema: GenMessage<CancelRequestResponse, {jsonType: CancelRequestResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 9);

/**
 * @generated from message guardianai.v1.expert.ApproveReportRequest
 */
export type ApproveReportRequest = Message<"guardianai.v1.expert.ApproveReportRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId: string;

  /**
   * 1-5 stars
   *
   * @generated from field: int32 rating = 3;
   */
  rating: number;

  /**
   * @generated from field: string feedback = 4;
   */
  feedback: string;
};

/**
 * @generated from message guardianai.v1.expert.ApproveReportRequest
 */
export type ApproveReportRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId?: string;

  /**
   * 1-5 stars
   *
   * @generated from field: int32 rating = 3;
   */
  rating?: number;

  /**
   * @generated from field: string feedback = 4;
   */
  feedback?: string;
};

/**
 * Describes the message guardianai.v1.expert.ApproveReportRequest.
 * Use `create(ApproveReportRequestSchema)` to create a new message.
 */
export const ApproveReportRequestSchema: GenMessage<ApproveReportRequest, {jsonType: ApproveReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 10);

/**
 * @generated from message guardianai.v1.expert.ApproveReportResponse
 */
export type ApproveReportResponse = Message<"guardianai.v1.expert.ApproveReportResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * From escrow to expert
   *
   * @generated from field: int64 credits_released = 3;
   */
  creditsReleased: bigint;
};

/**
 * @generated from message guardianai.v1.expert.ApproveReportResponse
 */
export type ApproveReportResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * From escrow to expert
   *
   * @generated from field: int64 credits_released = 3;
   */
  creditsReleased?: string;
};

/**
 * Describes the message guardianai.v1.expert.ApproveReportResponse.
 * Use `create(ApproveReportResponseSchema)` to create a new message.
 */
export const ApproveReportResponseSchema: GenMessage<ApproveReportResponse, {jsonType: ApproveReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 11);

/**
 * @generated from message guardianai.v1.expert.RejectReportRequest
 */
export type RejectReportRequest = Message<"guardianai.v1.expert.RejectReportRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId: string;

  /**
   * @generated from field: string rejection_reason = 3;
   */
  rejectionReason: string;

  /**
   * @generated from field: repeated string required_changes = 4;
   */
  requiredChanges: string[];
};

/**
 * @generated from message guardianai.v1.expert.RejectReportRequest
 */
export type RejectReportRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string client_user_id = 2;
   */
  clientUserId?: string;

  /**
   * @generated from field: string rejection_reason = 3;
   */
  rejectionReason?: string;

  /**
   * @generated from field: repeated string required_changes = 4;
   */
  requiredChanges?: string[];
};

/**
 * Describes the message guardianai.v1.expert.RejectReportRequest.
 * Use `create(RejectReportRequestSchema)` to create a new message.
 */
export const RejectReportRequestSchema: GenMessage<RejectReportRequest, {jsonType: RejectReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 12);

/**
 * @generated from message guardianai.v1.expert.RejectReportResponse
 */
export type RejectReportResponse = Message<"guardianai.v1.expert.RejectReportResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * DISPUTED
   *
   * @generated from field: guardianai.v1.expert.ExpertScanStatus new_status = 3;
   */
  newStatus: ExpertScanStatus;
};

/**
 * @generated from message guardianai.v1.expert.RejectReportResponse
 */
export type RejectReportResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * DISPUTED
   *
   * @generated from field: guardianai.v1.expert.ExpertScanStatus new_status = 3;
   */
  newStatus?: ExpertScanStatusJson;
};

/**
 * Describes the message guardianai.v1.expert.RejectReportResponse.
 * Use `create(RejectReportResponseSchema)` to create a new message.
 */
export const RejectReportResponseSchema: GenMessage<RejectReportResponse, {jsonType: RejectReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 13);

/**
 * @generated from message guardianai.v1.expert.ListAvailableJobsRequest
 */
export type ListAvailableJobsRequest = Message<"guardianai.v1.expert.ListAvailableJobsRequest"> & {
  /**
   * @generated from field: string expert_user_id = 1;
   */
  expertUserId: string;

  /**
   * @generated from field: guardianai.v1.expert.ScanType scan_type_filter = 2;
   */
  scanTypeFilter: ScanType;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.expert.ListAvailableJobsRequest
 */
export type ListAvailableJobsRequestJson = {
  /**
   * @generated from field: string expert_user_id = 1;
   */
  expertUserId?: string;

  /**
   * @generated from field: guardianai.v1.expert.ScanType scan_type_filter = 2;
   */
  scanTypeFilter?: ScanTypeJson;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.expert.ListAvailableJobsRequest.
 * Use `create(ListAvailableJobsRequestSchema)` to create a new message.
 */
export const ListAvailableJobsRequestSchema: GenMessage<ListAvailableJobsRequest, {jsonType: ListAvailableJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 14);

/**
 * @generated from message guardianai.v1.expert.ClaimJobRequest
 */
export type ClaimJobRequest = Message<"guardianai.v1.expert.ClaimJobRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId: string;
};

/**
 * @generated from message guardianai.v1.expert.ClaimJobRequest
 */
export type ClaimJobRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId?: string;
};

/**
 * Describes the message guardianai.v1.expert.ClaimJobRequest.
 * Use `create(ClaimJobRequestSchema)` to create a new message.
 */
export const ClaimJobRequestSchema: GenMessage<ClaimJobRequest, {jsonType: ClaimJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 15);

/**
 * @generated from message guardianai.v1.expert.ClaimJobResponse
 */
export type ClaimJobResponse = Message<"guardianai.v1.expert.ClaimJobResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;

  /**
   * ALREADY_CLAIMED, NOT_QUALIFIED, JOB_NOT_FOUND
   *
   * @generated from field: string error_code = 4;
   */
  errorCode: string;
};

/**
 * @generated from message guardianai.v1.expert.ClaimJobResponse
 */
export type ClaimJobResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;

  /**
   * ALREADY_CLAIMED, NOT_QUALIFIED, JOB_NOT_FOUND
   *
   * @generated from field: string error_code = 4;
   */
  errorCode?: string;
};

/**
 * Describes the message guardianai.v1.expert.ClaimJobResponse.
 * Use `create(ClaimJobResponseSchema)` to create a new message.
 */
export const ClaimJobResponseSchema: GenMessage<ClaimJobResponse, {jsonType: ClaimJobResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 16);

/**
 * @generated from message guardianai.v1.expert.StartWorkRequest
 */
export type StartWorkRequest = Message<"guardianai.v1.expert.StartWorkRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId: string;

  /**
   * Expert's assessment of scope
   *
   * @generated from field: string triage_notes = 3;
   */
  triageNotes: string;
};

/**
 * @generated from message guardianai.v1.expert.StartWorkRequest
 */
export type StartWorkRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId?: string;

  /**
   * Expert's assessment of scope
   *
   * @generated from field: string triage_notes = 3;
   */
  triageNotes?: string;
};

/**
 * Describes the message guardianai.v1.expert.StartWorkRequest.
 * Use `create(StartWorkRequestSchema)` to create a new message.
 */
export const StartWorkRequestSchema: GenMessage<StartWorkRequest, {jsonType: StartWorkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 17);

/**
 * @generated from message guardianai.v1.expert.StartWorkResponse
 */
export type StartWorkResponse = Message<"guardianai.v1.expert.StartWorkResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;

  /**
   * Time-boxed credential vault access
   *
   * @generated from field: string credential_access_token = 4;
   */
  credentialAccessToken: string;

  /**
   * @generated from field: int64 credential_access_expires_at = 5;
   */
  credentialAccessExpiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.expert.StartWorkResponse
 */
export type StartWorkResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;

  /**
   * Time-boxed credential vault access
   *
   * @generated from field: string credential_access_token = 4;
   */
  credentialAccessToken?: string;

  /**
   * @generated from field: int64 credential_access_expires_at = 5;
   */
  credentialAccessExpiresAt?: string;
};

/**
 * Describes the message guardianai.v1.expert.StartWorkResponse.
 * Use `create(StartWorkResponseSchema)` to create a new message.
 */
export const StartWorkResponseSchema: GenMessage<StartWorkResponse, {jsonType: StartWorkResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 18);

/**
 * @generated from message guardianai.v1.expert.SubmitReportRequest
 */
export type SubmitReportRequest = Message<"guardianai.v1.expert.SubmitReportRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId: string;

  /**
   * @generated from field: guardianai.v1.expert.ReportContent report = 3;
   */
  report?: ReportContent;
};

/**
 * @generated from message guardianai.v1.expert.SubmitReportRequest
 */
export type SubmitReportRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId?: string;

  /**
   * @generated from field: guardianai.v1.expert.ReportContent report = 3;
   */
  report?: ReportContentJson;
};

/**
 * Describes the message guardianai.v1.expert.SubmitReportRequest.
 * Use `create(SubmitReportRequestSchema)` to create a new message.
 */
export const SubmitReportRequestSchema: GenMessage<SubmitReportRequest, {jsonType: SubmitReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 19);

/**
 * @generated from message guardianai.v1.expert.ReportContent
 */
export type ReportContent = Message<"guardianai.v1.expert.ReportContent"> & {
  /**
   * @generated from field: string executive_summary = 1;
   */
  executiveSummary: string;

  /**
   * @generated from field: repeated guardianai.v1.expert.Finding findings = 2;
   */
  findings: Finding[];

  /**
   * @generated from field: string remediation_guidance = 3;
   */
  remediationGuidance: string;

  /**
   * 0-100
   *
   * @generated from field: int32 risk_score = 4;
   */
  riskScore: number;

  /**
   * URLs to evidence files
   *
   * @generated from field: repeated string attachments = 5;
   */
  attachments: string[];
};

/**
 * @generated from message guardianai.v1.expert.ReportContent
 */
export type ReportContentJson = {
  /**
   * @generated from field: string executive_summary = 1;
   */
  executiveSummary?: string;

  /**
   * @generated from field: repeated guardianai.v1.expert.Finding findings = 2;
   */
  findings?: FindingJson[];

  /**
   * @generated from field: string remediation_guidance = 3;
   */
  remediationGuidance?: string;

  /**
   * 0-100
   *
   * @generated from field: int32 risk_score = 4;
   */
  riskScore?: number;

  /**
   * URLs to evidence files
   *
   * @generated from field: repeated string attachments = 5;
   */
  attachments?: string[];
};

/**
 * Describes the message guardianai.v1.expert.ReportContent.
 * Use `create(ReportContentSchema)` to create a new message.
 */
export const ReportContentSchema: GenMessage<ReportContent, {jsonType: ReportContentJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 20);

/**
 * @generated from message guardianai.v1.expert.Finding
 */
export type Finding = Message<"guardianai.v1.expert.Finding"> & {
  /**
   * @generated from field: string finding_id = 1;
   */
  findingId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * CRITICAL, HIGH, MEDIUM, LOW, INFO
   *
   * @generated from field: string severity = 4;
   */
  severity: string;

  /**
   * @generated from field: string cvss_score = 5;
   */
  cvssScore: string;

  /**
   * @generated from field: string affected_asset = 6;
   */
  affectedAsset: string;

  /**
   * @generated from field: string evidence = 7;
   */
  evidence: string;

  /**
   * @generated from field: string recommendation = 8;
   */
  recommendation: string;
};

/**
 * @generated from message guardianai.v1.expert.Finding
 */
export type FindingJson = {
  /**
   * @generated from field: string finding_id = 1;
   */
  findingId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * CRITICAL, HIGH, MEDIUM, LOW, INFO
   *
   * @generated from field: string severity = 4;
   */
  severity?: string;

  /**
   * @generated from field: string cvss_score = 5;
   */
  cvssScore?: string;

  /**
   * @generated from field: string affected_asset = 6;
   */
  affectedAsset?: string;

  /**
   * @generated from field: string evidence = 7;
   */
  evidence?: string;

  /**
   * @generated from field: string recommendation = 8;
   */
  recommendation?: string;
};

/**
 * Describes the message guardianai.v1.expert.Finding.
 * Use `create(FindingSchema)` to create a new message.
 */
export const FindingSchema: GenMessage<Finding, {jsonType: FindingJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 21);

/**
 * @generated from message guardianai.v1.expert.SubmitReportResponse
 */
export type SubmitReportResponse = Message<"guardianai.v1.expert.SubmitReportResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;
};

/**
 * @generated from message guardianai.v1.expert.SubmitReportResponse
 */
export type SubmitReportResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;
};

/**
 * Describes the message guardianai.v1.expert.SubmitReportResponse.
 * Use `create(SubmitReportResponseSchema)` to create a new message.
 */
export const SubmitReportResponseSchema: GenMessage<SubmitReportResponse, {jsonType: SubmitReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 22);

/**
 * @generated from message guardianai.v1.expert.DeclineJobRequest
 */
export type DeclineJobRequest = Message<"guardianai.v1.expert.DeclineJobRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId: string;

  /**
   * @generated from field: string decline_reason = 3;
   */
  declineReason: string;
};

/**
 * @generated from message guardianai.v1.expert.DeclineJobRequest
 */
export type DeclineJobRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId?: string;

  /**
   * @generated from field: string decline_reason = 3;
   */
  declineReason?: string;
};

/**
 * Describes the message guardianai.v1.expert.DeclineJobRequest.
 * Use `create(DeclineJobRequestSchema)` to create a new message.
 */
export const DeclineJobRequestSchema: GenMessage<DeclineJobRequest, {jsonType: DeclineJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 23);

/**
 * @generated from message guardianai.v1.expert.DeclineJobResponse
 */
export type DeclineJobResponse = Message<"guardianai.v1.expert.DeclineJobResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Back to OPEN status
   *
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;
};

/**
 * @generated from message guardianai.v1.expert.DeclineJobResponse
 */
export type DeclineJobResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * Back to OPEN status
   *
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;
};

/**
 * Describes the message guardianai.v1.expert.DeclineJobResponse.
 * Use `create(DeclineJobResponseSchema)` to create a new message.
 */
export const DeclineJobResponseSchema: GenMessage<DeclineJobResponse, {jsonType: DeclineJobResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 24);

/**
 * @generated from message guardianai.v1.expert.GetJobDetailsRequest
 */
export type GetJobDetailsRequest = Message<"guardianai.v1.expert.GetJobDetailsRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId: string;
};

/**
 * @generated from message guardianai.v1.expert.GetJobDetailsRequest
 */
export type GetJobDetailsRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string expert_user_id = 2;
   */
  expertUserId?: string;
};

/**
 * Describes the message guardianai.v1.expert.GetJobDetailsRequest.
 * Use `create(GetJobDetailsRequestSchema)` to create a new message.
 */
export const GetJobDetailsRequestSchema: GenMessage<GetJobDetailsRequest, {jsonType: GetJobDetailsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 25);

/**
 * @generated from message guardianai.v1.expert.JobDetailsResponse
 */
export type JobDetailsResponse = Message<"guardianai.v1.expert.JobDetailsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;

  /**
   * Anonymized or revealed based on stage
   *
   * @generated from field: string client_name = 4;
   */
  clientName: string;

  /**
   * @generated from field: guardianai.v1.expert.ScopeDefinition full_scope = 5;
   */
  fullScope?: ScopeDefinition;
};

/**
 * @generated from message guardianai.v1.expert.JobDetailsResponse
 */
export type JobDetailsResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;

  /**
   * Anonymized or revealed based on stage
   *
   * @generated from field: string client_name = 4;
   */
  clientName?: string;

  /**
   * @generated from field: guardianai.v1.expert.ScopeDefinition full_scope = 5;
   */
  fullScope?: ScopeDefinitionJson;
};

/**
 * Describes the message guardianai.v1.expert.JobDetailsResponse.
 * Use `create(JobDetailsResponseSchema)` to create a new message.
 */
export const JobDetailsResponseSchema: GenMessage<JobDetailsResponse, {jsonType: JobDetailsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 26);

/**
 * @generated from message guardianai.v1.expert.ListMyAssignedJobsRequest
 */
export type ListMyAssignedJobsRequest = Message<"guardianai.v1.expert.ListMyAssignedJobsRequest"> & {
  /**
   * @generated from field: string expert_user_id = 1;
   */
  expertUserId: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanStatus status_filter = 2;
   */
  statusFilter: ExpertScanStatus;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.expert.ListMyAssignedJobsRequest
 */
export type ListMyAssignedJobsRequestJson = {
  /**
   * @generated from field: string expert_user_id = 1;
   */
  expertUserId?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanStatus status_filter = 2;
   */
  statusFilter?: ExpertScanStatusJson;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.expert.ListMyAssignedJobsRequest.
 * Use `create(ListMyAssignedJobsRequestSchema)` to create a new message.
 */
export const ListMyAssignedJobsRequestSchema: GenMessage<ListMyAssignedJobsRequest, {jsonType: ListMyAssignedJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 27);

/**
 * @generated from message guardianai.v1.expert.AdminForceCloseRequest
 */
export type AdminForceCloseRequest = Message<"guardianai.v1.expert.AdminForceCloseRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId: string;

  /**
   * APPROVE, CANCEL, REFUND
   *
   * @generated from field: string resolution = 3;
   */
  resolution: string;

  /**
   * @generated from field: string admin_notes = 4;
   */
  adminNotes: string;
};

/**
 * @generated from message guardianai.v1.expert.AdminForceCloseRequest
 */
export type AdminForceCloseRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId?: string;

  /**
   * APPROVE, CANCEL, REFUND
   *
   * @generated from field: string resolution = 3;
   */
  resolution?: string;

  /**
   * @generated from field: string admin_notes = 4;
   */
  adminNotes?: string;
};

/**
 * Describes the message guardianai.v1.expert.AdminForceCloseRequest.
 * Use `create(AdminForceCloseRequestSchema)` to create a new message.
 */
export const AdminForceCloseRequestSchema: GenMessage<AdminForceCloseRequest, {jsonType: AdminForceCloseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 28);

/**
 * @generated from message guardianai.v1.expert.AdminForceCloseResponse
 */
export type AdminForceCloseResponse = Message<"guardianai.v1.expert.AdminForceCloseResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;
};

/**
 * @generated from message guardianai.v1.expert.AdminForceCloseResponse
 */
export type AdminForceCloseResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;
};

/**
 * Describes the message guardianai.v1.expert.AdminForceCloseResponse.
 * Use `create(AdminForceCloseResponseSchema)` to create a new message.
 */
export const AdminForceCloseResponseSchema: GenMessage<AdminForceCloseResponse, {jsonType: AdminForceCloseResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 29);

/**
 * @generated from message guardianai.v1.expert.AdminReassignJobRequest
 */
export type AdminReassignJobRequest = Message<"guardianai.v1.expert.AdminReassignJobRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId: string;

  /**
   * @generated from field: string new_expert_user_id = 3;
   */
  newExpertUserId: string;

  /**
   * @generated from field: string reassignment_reason = 4;
   */
  reassignmentReason: string;
};

/**
 * @generated from message guardianai.v1.expert.AdminReassignJobRequest
 */
export type AdminReassignJobRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId?: string;

  /**
   * @generated from field: string new_expert_user_id = 3;
   */
  newExpertUserId?: string;

  /**
   * @generated from field: string reassignment_reason = 4;
   */
  reassignmentReason?: string;
};

/**
 * Describes the message guardianai.v1.expert.AdminReassignJobRequest.
 * Use `create(AdminReassignJobRequestSchema)` to create a new message.
 */
export const AdminReassignJobRequestSchema: GenMessage<AdminReassignJobRequest, {jsonType: AdminReassignJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 30);

/**
 * @generated from message guardianai.v1.expert.AdminReassignJobResponse
 */
export type AdminReassignJobResponse = Message<"guardianai.v1.expert.AdminReassignJobResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequest;
};

/**
 * @generated from message guardianai.v1.expert.AdminReassignJobResponse
 */
export type AdminReassignJobResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.expert.ExpertScanRequest request = 3;
   */
  request?: ExpertScanRequestJson;
};

/**
 * Describes the message guardianai.v1.expert.AdminReassignJobResponse.
 * Use `create(AdminReassignJobResponseSchema)` to create a new message.
 */
export const AdminReassignJobResponseSchema: GenMessage<AdminReassignJobResponse, {jsonType: AdminReassignJobResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_expert_expert_scan, 31);

/**
 * @generated from enum guardianai.v1.expert.ExpertScanStatus
 */
export enum ExpertScanStatus {
  /**
   * @generated from enum value: EXPERT_SCAN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Awaiting expert claim
   *
   * @generated from enum value: EXPERT_SCAN_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * Expert reviewing scope
   *
   * @generated from enum value: EXPERT_SCAN_STATUS_TRIAGE = 2;
   */
  TRIAGE = 2,

  /**
   * Expert actively working
   *
   * @generated from enum value: EXPERT_SCAN_STATUS_IN_PROGRESS = 3;
   */
  IN_PROGRESS = 3,

  /**
   * Report submitted, awaiting approval
   *
   * @generated from enum value: EXPERT_SCAN_STATUS_REPORT_READY = 4;
   */
  REPORT_READY = 4,

  /**
   * Completed and approved
   *
   * @generated from enum value: EXPERT_SCAN_STATUS_CLOSED = 5;
   */
  CLOSED = 5,

  /**
   * Cancelled (by client or admin)
   *
   * @generated from enum value: EXPERT_SCAN_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,

  /**
   * Client rejected, under review
   *
   * @generated from enum value: EXPERT_SCAN_STATUS_DISPUTED = 7;
   */
  DISPUTED = 7,
}

/**
 * @generated from enum guardianai.v1.expert.ExpertScanStatus
 */
export type ExpertScanStatusJson = "EXPERT_SCAN_STATUS_UNSPECIFIED" | "EXPERT_SCAN_STATUS_OPEN" | "EXPERT_SCAN_STATUS_TRIAGE" | "EXPERT_SCAN_STATUS_IN_PROGRESS" | "EXPERT_SCAN_STATUS_REPORT_READY" | "EXPERT_SCAN_STATUS_CLOSED" | "EXPERT_SCAN_STATUS_CANCELLED" | "EXPERT_SCAN_STATUS_DISPUTED";

/**
 * Describes the enum guardianai.v1.expert.ExpertScanStatus.
 */
export const ExpertScanStatusSchema: GenEnum<ExpertScanStatus, ExpertScanStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_expert_expert_scan, 0);

/**
 * @generated from enum guardianai.v1.expert.ServiceTier
 */
export enum ServiceTier {
  /**
   * @generated from enum value: SERVICE_TIER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 24-48 hour SLA
   *
   * @generated from enum value: SERVICE_TIER_BASIC = 1;
   */
  BASIC = 1,

  /**
   * 12-24 hour SLA
   *
   * @generated from enum value: SERVICE_TIER_PRO = 2;
   */
  PRO = 2,

  /**
   * 4-8 hour SLA
   *
   * @generated from enum value: SERVICE_TIER_ENTERPRISE = 3;
   */
  ENTERPRISE = 3,
}

/**
 * @generated from enum guardianai.v1.expert.ServiceTier
 */
export type ServiceTierJson = "SERVICE_TIER_UNSPECIFIED" | "SERVICE_TIER_BASIC" | "SERVICE_TIER_PRO" | "SERVICE_TIER_ENTERPRISE";

/**
 * Describes the enum guardianai.v1.expert.ServiceTier.
 */
export const ServiceTierSchema: GenEnum<ServiceTier, ServiceTierJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_expert_expert_scan, 1);

/**
 * @generated from enum guardianai.v1.expert.ScanType
 */
export enum ScanType {
  /**
   * @generated from enum value: SCAN_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SCAN_TYPE_PENETRATION_TEST = 1;
   */
  PENETRATION_TEST = 1,

  /**
   * @generated from enum value: SCAN_TYPE_CLOUD_AUDIT = 2;
   */
  CLOUD_AUDIT = 2,

  /**
   * @generated from enum value: SCAN_TYPE_FORENSIC_ANALYSIS = 3;
   */
  FORENSIC_ANALYSIS = 3,

  /**
   * @generated from enum value: SCAN_TYPE_COMPLIANCE_REVIEW = 4;
   */
  COMPLIANCE_REVIEW = 4,

  /**
   * Future: AI/LLM trust scoring
   *
   * @generated from enum value: SCAN_TYPE_AI_MODEL_AUDIT = 5;
   */
  AI_MODEL_AUDIT = 5,
}

/**
 * @generated from enum guardianai.v1.expert.ScanType
 */
export type ScanTypeJson = "SCAN_TYPE_UNSPECIFIED" | "SCAN_TYPE_PENETRATION_TEST" | "SCAN_TYPE_CLOUD_AUDIT" | "SCAN_TYPE_FORENSIC_ANALYSIS" | "SCAN_TYPE_COMPLIANCE_REVIEW" | "SCAN_TYPE_AI_MODEL_AUDIT";

/**
 * Describes the enum guardianai.v1.expert.ScanType.
 */
export const ScanTypeSchema: GenEnum<ScanType, ScanTypeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_expert_expert_scan, 2);

/**
 * CLIENT OPERATIONS
 *
 * @generated from service guardianai.v1.expert.ExpertScanService
 */
export const ExpertScanService: GenService<{
  /**
   * Create a new expert scan request (locks credits in escrow)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.CreateRequest
   */
  createRequest: {
    methodKind: "unary";
    input: typeof CreateExpertScanRequestSchema;
    output: typeof ExpertScanRequestResponseSchema;
  },
  /**
   * List client's own requests
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.ListMyRequests
   */
  listMyRequests: {
    methodKind: "unary";
    input: typeof ListMyRequestsRequestSchema;
    output: typeof ListRequestsResponseSchema;
  },
  /**
   * Get request status and details
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.GetRequestStatus
   */
  getRequestStatus: {
    methodKind: "unary";
    input: typeof GetRequestStatusRequestSchema;
    output: typeof ExpertScanRequestResponseSchema;
  },
  /**
   * Cancel request (only if OPEN - refunds escrow)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.CancelRequest
   */
  cancelRequest: {
    methodKind: "unary";
    input: typeof CancelRequestRequestSchema;
    output: typeof CancelRequestResponseSchema;
  },
  /**
   * Approve completed report (releases escrow to expert)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.ApproveReport
   */
  approveReport: {
    methodKind: "unary";
    input: typeof ApproveReportRequestSchema;
    output: typeof ApproveReportResponseSchema;
  },
  /**
   * Reject report with feedback (may trigger rework)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.RejectReport
   */
  rejectReport: {
    methodKind: "unary";
    input: typeof RejectReportRequestSchema;
    output: typeof RejectReportResponseSchema;
  },
  /**
   * List available jobs matching expert's skills
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.ListAvailableJobs
   */
  listAvailableJobs: {
    methodKind: "unary";
    input: typeof ListAvailableJobsRequestSchema;
    output: typeof ListRequestsResponseSchema;
  },
  /**
   * Claim a job (moves to TRIAGE)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.ClaimJob
   */
  claimJob: {
    methodKind: "unary";
    input: typeof ClaimJobRequestSchema;
    output: typeof ClaimJobResponseSchema;
  },
  /**
   * Start work (moves to IN_PROGRESS, enables credential vault access)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.StartWork
   */
  startWork: {
    methodKind: "unary";
    input: typeof StartWorkRequestSchema;
    output: typeof StartWorkResponseSchema;
  },
  /**
   * Submit completed report (moves to REPORT_READY)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.SubmitReport
   */
  submitReport: {
    methodKind: "unary";
    input: typeof SubmitReportRequestSchema;
    output: typeof SubmitReportResponseSchema;
  },
  /**
   * Decline job after triage (moves back to OPEN, expert replaced)
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.DeclineJob
   */
  declineJob: {
    methodKind: "unary";
    input: typeof DeclineJobRequestSchema;
    output: typeof DeclineJobResponseSchema;
  },
  /**
   * Get job details for expert
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.GetJobDetails
   */
  getJobDetails: {
    methodKind: "unary";
    input: typeof GetJobDetailsRequestSchema;
    output: typeof JobDetailsResponseSchema;
  },
  /**
   * List expert's assigned jobs
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.ListMyAssignedJobs
   */
  listMyAssignedJobs: {
    methodKind: "unary";
    input: typeof ListMyAssignedJobsRequestSchema;
    output: typeof ListRequestsResponseSchema;
  },
  /**
   * Force close disputed request
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.AdminForceClose
   */
  adminForceClose: {
    methodKind: "unary";
    input: typeof AdminForceCloseRequestSchema;
    output: typeof AdminForceCloseResponseSchema;
  },
  /**
   * Reassign job to different expert
   *
   * @generated from rpc guardianai.v1.expert.ExpertScanService.AdminReassignJob
   */
  adminReassignJob: {
    methodKind: "unary";
    input: typeof AdminReassignJobRequestSchema;
    output: typeof AdminReassignJobResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_expert_expert_scan, 0);

